import { jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 5L10 14L6.5 10.5L4 13L10 19L21.5 7.5L19 5Z", fill: "currentColor" }) });
export default SvgCheckmark;
